<div class="row-header">
  <div class="name f-heading-s">
    @if (border().address; as address) {
      <p>{{ address.zipCode }} {{ address.city }}</p>
    } @else {
      <onyx-address
        [address]="$any({ coordinates: border().coordinates })"
        format="coordinates"
      ></onyx-address>
    }

    <onyx-flags [flags]="[border().from, border().to]" [size]="16"></onyx-flags>
  </div>

  <p class="f-body-xs f-muted">{{ 'labels.borderCrossing' | translate }}</p>
</div>

<div class="row-actions">
  <onyx-icon-button
    variant="transparent"
    color="gray"
    [size]="24"
    icon="copy-outlined"
    [circle]="true"
    onyxTooltip="labels.copyCoordinates"
    (click)="copyCoordinates()"
  ></onyx-icon-button>
</div>
